import React from 'react';
import { useSelector } from 'react-redux';

import { batchDetailsSelector } from 'features/satManagement';
import BatchDetailsTableHeader from 'pages/BatchDetailsTableHeader';
import BatchDetailsTableRow from 'pages/BatchDetailsTableRow';
import GlobalLoader from 'components/GlobalLoader';
import styles from './BatchDetailsTable.module.scss';
import Table from 'components/Table';
import TableBody from 'components/TableBody';

function BatchDetailsTable() {
  const batchDetails = useSelector(batchDetailsSelector);

  return (
    <>
      <GlobalLoader isVisible={false} />
      {batchDetails?.data?.length > 0 ? (
        <Table className={styles.root}>
          <BatchDetailsTableHeader />
          <TableBody className={styles.rows}>
            {batchDetails?.data.map((item) => (
              <BatchDetailsTableRow
                submission={item}
                key={item.id}
              />
            ))}
          </TableBody>
        </Table>
      ) : null}
    </>
  );
}

export default BatchDetailsTable;
